import ActionCable from "actioncable";
import { getAdminAuthToken, getAuthToken } from "../api";

let consumer: ActionCable.Cable | null = null;

export const getActionCableConsumer = (
  extraParams: Record<string, string> = {}
): ActionCable.Cable => {
  if (!consumer) {
    let authToken;
    if (extraParams.resourceType === 'admin') {
      authToken = getAdminAuthToken();
    } else {
      authToken = getAuthToken();
    }

    const params = {
      'access-token': authToken['access-token'],
      client: authToken.client,
      uid: authToken.uid,
      resource_type: extraParams.resourceType ?? 'employee',
      ...extraParams,
    };

    const queryString = new URLSearchParams(params).toString();
    const URL = `${import.meta.env.VITE_ACTION_CABLE}/cable?${queryString}`;

    consumer = ActionCable.createConsumer(URL);
  }
  return consumer;
};
